import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Tabs, Typography, Spin, Row, Col, Input, message, Table, Icon, Button, Popconfirm, Form, Select } from 'antd'
import FromInput from '../from/Input'
import { Queries, Mutations } from '../../../graphql'

import SelectStatus from '../from/SelectStatus'
import moment from 'moment'

const { TabPane } = Tabs
const { Text, Title } = Typography
const { Option } = Select;

const newsDataProfile = '';

class FormHospitalCreate extends Component {
	state = {
		dataFormHospitalHospital:[],
        dataProvince:[],
        dataAmphur: [],
        dataDistrict: [],
        idProvince:null,
        idAmphur:null,
		idDistrict :null,
        idPostalCode:null,
	}

    handleSubmit = async (e) => {
        const { form, afterSubmit, client } = this.props
        const { telNo, otpToken, refCode } = this.state
        console.log(e)
		// await e.preventDefault()
		form.validateFields(async (err, values) => {
            afterSubmit()
		// 	if (!err) {
        //         try {
                    
        //             const { data, errors } = await client.mutate({
        //                 mutation: Mutations.changePhoneNumber,
        //                 variables: {
        //                     telNo,
        //                     otp:{
        //                         otpToken: otpToken,
        //                         refCode: refCode,
        //                         otpCode: values.otp
        //                     }
        //                 }
        //             })

        //             console.log(data)

        //             if(data){
        //                 message.success("ส่งเพื่อดำเนินการเรียบร้อย")
        //                 setTimeout(() => {
        //                     window.location.reload();
        //                 }, 600);
        //             }
        //         }catch (error) {
                    
        //         }
		// 	}
		})
	}

    formSelect = (label, name, value, dataOptions, disabled, onChangeFilter) =>{
        const { getFieldDecorator } = this.props.form;
        return (
            <>
                {
                    <Form.Item label={label} style={{ marginBottom:"0px" }}>
                        { getFieldDecorator(name, {
                            initialValue: value,
                            rules:  [
                                { 
                                    required: true, 
                                    message: 'กรุณากรอกหรือเลือก '+label,
                                }
                            ],
                        })(
                            <Select  style={{ width: "100%" }}  disabled={disabled} onChange={(e) => onChangeFilter(e, true)}>
                                <Option value="">กรุณาเลือก </Option>
                                {
                                    dataOptions.length !== 0 &&
                                    dataOptions.map((value, keys)=>
                                        <Option value={ value.id }>{ value.name } </Option>
                                    )
                                }
                            </Select>
                        )}
                    </Form.Item>
                }
            </>
        )
    }

    filterProvince = async (id = null, checkSelectForm) =>{
        const { client, location } = this.props
        const { dataFormHospital } = this.state
		const { data, errors } = await client.query({
			query: Queries.dropdownListProvince,
		})

		await this.setState({
            idProvince:id,
			dataProvince:data.dropdownListProvince
		})

        let checkIdSelect = data.dropdownListProvince.filter(data => data.id == id);

        if(checkIdSelect.length == 0){
            // dataFormHospital.province = ''
            await this.props.form.setFieldsValue({
                province: '',
            })
            await this.setState({
                idProvince: null
            })
        }

        if(checkSelectForm){
			// dataFormHospital.amphur = ''
			// dataFormHospital.district = ''
            // dataFormHospital.postalCode = ''
            this.props.form.setFieldsValue({
                amphur: '',
                district: '',
                postalCode:''
            })
            await this.filterAmphur()
            // await this.filterDistrict()
        }
    }

    filterAmphur = async (id = null, checkSelectForm) =>{
        const { idProvince, dataFormHospital } = this.state
		const { client, location } = this.props

        if(idProvince){
            const { data, errors } = await client.query({
                query: Queries.dropdownListAmphur,
                variables: {
                    id : idProvince
                }
            })
    
            if(data){
                let checkIdSelect = data.dropdownListAmphur.filter(data => data.id == id);
    
                if(checkIdSelect.length == 0){
                    // dataFormHospital.amphur = ''
                    await this.props.form.setFieldsValue({
                        amphur: '',
                    })
                    await this.setState({
                        idAmphur: null
                    })
                }
    
                // console.log(data.dropdownListAmphur)
                await this.setState({
                    idAmphur:id,
                    dataAmphur:data.dropdownListAmphur
                })

                if(checkSelectForm){
                    // dataFormHospital.district = ''
                    // dataFormHospital.postalCode = ''
                    this.props.form.setFieldsValue({
                        district: '',
                        postalCode:''
                    })
                }
    
                if(id){
                    await this.filterDistrict()
                }
            }
        }else{
            await this.props.form.setFieldsValue({
                amphur: '',
            })
            await this.setState({
                idAmphur: null
            })
        }
    }

    filterDistrict = async (id = null) =>{
        const { idProvince, dataFormHospital, idAmphur } = this.state
		const { client, location } = this.props
        
        if(idAmphur){
            const { data, errors } = await client.query({
                query: Queries.dropdownListDistrict,
                variables: {
                    id : idAmphur
                }
            })
    
            if(data){
                let checkIdSelect = data.dropdownListDistrict.filter(data => data.id == id);
    
                if(checkIdSelect.length == 0){
                    // dataFormHospital.idDistrict = ''
                    // dataFormHospital.postalCode = ''
                    await this.props.form.setFieldsValue({
                        idDistrict:'',
                        postalCode: '',
                    })
                }
    
                data.dropdownListDistrict.filter(data => data.id == id).map(dataFilter => {
                    // dataFormHospital.postalCode = dataFilter.postCode
                    this.props.form.setFieldsValue({
                        postalCode: dataFilter.postCode
                    })
                })
    
                await this.setState({
                    idDistrict:id,
                    dataDistrict:data.dropdownListDistrict,
                })
            
            }
    
        }else{
            // dataFormHospital.district = ''
            // dataFormHospital.postalCode = ''
            await this.props.form.setFieldsValue({
                district: '',
                postalCode: ''
            })
        }
    }

	async componentDidMount(){
        const { dataForm } = this.props
        const { dataFormHospital } =  this.state

        if(dataForm){
            // await this.filterProvince(dataForm.province, false)
            // await this.filterAmphur(dataForm.amphur, false)
            // await this.filterDistrict(dataForm.district)
        }else{
            await this.filterProvince('', false)
        }
        // console.log('sss',dataFormHospital)
		// await this.fetchProfile()
    }

	render() {
		const { match } = this.props
        const { getFieldDecorator } = this.props.form
        const { dataFormHospital, dataProvince, dataAmphur, dataDistrict, } = this.state
		return (
            <div className="card-container" id="page-profile">
                <div className="px-5 py-1 card-bg-green">
                    <Form >
                        <Row gutter={16} type="flex" justify="left" align="top" className="box-color-white mb-5" >
                            <Col xs={24} md={24} className="pt-2">
                                <strong className="color-red">
                                    เพิ่มข้อมูลสถานพยาบาล
                                </strong>
                            </Col>

                            <Col xs={ 24 } md={24} >
                                <FromInput value={null} required={false} name={"code"} label="ชื่อสถานพยาบาล" mode={"text"} />
                            </Col>

                            <Col xs={ 24 } md={24} >
                                <FromInput value={null} required={false} name={"code"} label="ที่อยู่" mode={"text"} />
                            </Col>

                            <Col xs={ 24 } md={8}>
                                { this.formSelect(
                                        'จังหวัด', 
                                        'province', 
                                        dataFormHospital ? dataFormHospital.province ? dataFormHospital.province : '' : '',
                                        dataProvince,
                                        false,
                                        this.filterProvince
                                    ) 
                                }
                            </Col>

                            <Col xs={ 24 } md={8}>
                                { this.formSelect(
                                        'อำเภอ/เขต', 
                                        'amphur', 
                                        dataFormHospital ? dataFormHospital.amphur ? dataFormHospital.amphur : '' : '',
                                        dataAmphur,
                                        false,
                                        this.filterAmphur
                                    ) 
                                }
                            </Col>

                            <Col xs={ 24 } md={8}>
                                { this.formSelect(
                                        'ตำบล/แขวง', 
                                        'district', 
                                        dataFormHospital ? dataFormHospital.district ? dataFormHospital.district : '' : '',
                                        dataDistrict,
                                        false,
                                        this.filterDistrict
                                    ) 
                                }
                            </Col>

                            <Col xs={ 24 } md={8}>
                                <Form.Item label={'รหัสไปรษณีย์'} style={{ marginBottom:"0px" }}>
                                    { getFieldDecorator('postalCode', {
                                        initialValue: dataFormHospital ? dataFormHospital.postalCode ? dataFormHospital.postalCode : '' : '',
                                        rules:  [
                                            {
                                                message: 'กรุณากรอกรหัสไปรษณีย์ให้ถูกต้อง',
                                                // required: true, 
                                            }
                                        ],
                                    })(
                                        <Input 
                                            disabled={true}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={ 24 } md={8} >
                                <FromInput value={null} required={false} name={"code"} label="เบอร์โทร" mode={"text"} />
                            </Col>

                            <Col xs={ 24 } md={8} >
                                <FromInput value={null} required={false} name={"code"} label="โทรสาร" mode={"text"} />
                            </Col>

                            <Col xs={ 24 } md={8} >
                                <Form.Item label={"ฝ่าย"}>
                                    { getFieldDecorator("ประเภทสถานพยาบาล", {
                                        initialValue: "",
                                        rules:  [{ 
                                            required: true, 
                                            message: 'กรุณากรอกหรือเลือก สถานพยาบาล',
                                        }],
                                    })(
                                        <Select style={{ width: "100%" }}>
                                            <Option value="jack">Jack</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col xs={24} md={24} align={"center"} className="mt-5">
                                <Button type="primary" className="ml-2 color-white" htmlType="submit" onClick={this.handleSubmit}>
                                    เพิ่ม
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
		)
	}
}

FormHospitalCreate.defaultProps = {
	autoFocus: false
}

FormHospitalCreate.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedFormHospitalCreate = Form.create()(FormHospitalCreate)

export default withApollo(WrappedFormHospitalCreate)